import { EssentialsMonthlyExpiryDateProps } from '../../types/components/shared/EssentialsMonthlyExpiryDate';

import { ClockIcon } from '../../modules/Icons';

const EssentialsMonthlyExpiryDate: React.FC<EssentialsMonthlyExpiryDateProps> = ({
  expiryDate,
}) => {
  if (!expiryDate) return;

  const formattedEcExpiryDate = new Date(expiryDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return (
    <div cy-test-id="ec-monthly-expiry-date" className="flex gap-[6px] items-center w-fit">
      <ClockIcon stroke="#24C1FF" />
      <span className="text-blue-800 inter text-14 leading-22">Available until {formattedEcExpiryDate}</span>
    </div>
  );
}

export default EssentialsMonthlyExpiryDate;
